import React from "react";

/**
 * Screen — mobile-first page container.
 * Always max-width ~480px, centered, generous vertical rhythm.
 * `withBottomNav` reserves space for the sticky nav.
 */
export function Screen({
  children,
  className = "",
  withBottomNav = true,
  testId,
}) {
  return (
    <div
      className={`min-h-[100dvh] w-full flex justify-center ${className}`}
      data-testid={testId}
    >
      <div
        className={`w-full max-w-[480px] px-6 pt-8 ${
          withBottomNav ? "pb-32" : "pb-10"
        } dc-fade-in`}
      >
        {children}
      </div>
    </div>
  );
}
